<template>
  <div class="to-young row align-items-center h-100">
    <div class="col align-self-center text-center">
      <img src="../assets/img/loading.svg" height="100px">
      <h4>No questions for {{details.firstName}}.</h4>
      <p>Our screener addresses age groups starting at 7 months.</p>
      <p>In the meantime keep talking with {{details.firstName}} as much as possible and try our screener again when he turns 7 months old.</p>
      <router-link to="/screener/basics/name" class="btn btn-purple btn-lg">Try again</router-link>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    details: function () {
      return JSON.parse(window.localStorage.getItem('childDetails'))
    }
  }
}
</script>

<style lang="less" scoped>
.to-young {
  h4 {
    margin: 30px 0;
  }

  .btn {
    margin-top: 30px;
  }
}
</style>
